import { render } from "./modulos.vue?vue&type=template&id=20c0727e"
import script from "./modulos.vue?vue&type=script&lang=js"
export * from "./modulos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__